import { Button } from "@cynthai/ui";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

import PageContainer from "@/core/ui/layout/PageContainer";
import PageHeader from "@/core/ui/layout/PageHeader";
import { LedgerSourceQueryEditor } from "@/features/classification/components/template-form/LedgerSourceQueryEditor";
import { StatementTaxonomyEditor } from "@/features/classification/components/template-form/StatementTaxonomyEditor";
import { m } from "@/paraglide/messages";

export const Route = createFileRoute(
  "/_protected/template-editor/statement-trees/$taxonomyId",
)({
  component: AuditStatementTreeRoute,
});

function AuditStatementTreeRoute() {
  const { taxonomyId } = Route.useParams();
  return <AuditStatementTreeEditorPage taxonomyId={taxonomyId} />;
}

export function AuditStatementTreeEditorPage({
  taxonomyId,
}: Readonly<{ taxonomyId: string }>) {
  const navigate = useNavigate();
  return (
    <div className="scroll-area flex min-h-0 flex-1 flex-col overflow-y-auto [&>*]:shrink-0">
      <PageHeader title={m.template_editor_category_statement_trees()} />
      <PageContainer className="h-auto overflow-visible pb-16 [&>*]:shrink-0">
        <Button
          size="sm"
          variant="ghost"
          className="self-start"
          onPress={() =>
            navigate({
              to: "/template-editor",
              search: {
                status: "approved",
                category: "statement_taxonomy",
                projectType: "audit",
              },
            })
          }
        >
          {m.statement_taxonomy_editor_back()}
        </Button>
        <StatementTaxonomyEditor
          key={taxonomyId}
          taxonomyId={taxonomyId}
          canImportCsv
          sourceQuery={<LedgerSourceQueryEditor templateId={taxonomyId} />}
        />
      </PageContainer>
    </div>
  );
}
